(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cro-tungsten-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  document.querySelectorAll('.cro-calc').forEach(function (root) {
    if (root.__croCalcBound) return;
    root.__croCalcBound = true;

    var chainMultiplier = parseFloat(root.dataset.chainMultiplier) || 10;
    var minutesPerTank = parseFloat(root.dataset.minutesPerTank) || 30;
    var chainPrice = parseFloat(root.dataset.chainPrice) || 114;

    var humourBands = [
      { max: 5,   line: "A few smoke-o breaks back in your pocket." },
      { max: 15,  line: "That's a few cold ones earned, mate." },
      { max: 30,  line: "Your file's gonna start feeling neglected." },
      { max: 60,  line: "Serious time back at the bar, not the bench." },
      { max: 120, line: "More cutting, less mucking around." },
      { max: 9999, line: "You'd save more time than a coffee addict at smoko." }
    ];

    function getInputs() {
      return {
        hours_per_week: parseFloat(root.querySelector('[data-input="hours_per_week"]').value),
        sharpen_minutes: parseFloat(root.querySelector('[data-input="sharpen_minutes"]').value),
        hourly_value: parseFloat(root.querySelector('[data-input="hourly_value"]').value),
        timber_intensity: parseInt((root.querySelector('[data-input="timber_intensity"]:checked') || {}).value || '2', 10)
      };
    }

    function calc(inputs) {
      var intensityMultiplier = inputs.timber_intensity === 1 ? 0.7 :
                                inputs.timber_intensity === 2 ? 1.0 : 1.4;
      var totalHoursPerYear = inputs.hours_per_week * 52;
      // 1 fuel tank = ~30 min cutting (tunable). Standard chain dulls every 1 tank.
      var fuelTanksPerYear = (totalHoursPerYear * 60) / minutesPerTank;
      var standardSessions = fuelTanksPerYear * intensityMultiplier;
      var tungstenSessions = standardSessions / chainMultiplier;
      var sessionsSaved = Math.max(0, standardSessions - tungstenSessions);
      var hoursSaved = (sessionsSaved * inputs.sharpen_minutes) / 60;
      var dollarsSaved = hoursSaved * inputs.hourly_value;
      var chainsBought = chainPrice > 0 ? Math.floor(dollarsSaved / chainPrice) : 0;
      var revenueDays = Math.floor(hoursSaved / 8);
      return {
        sessionsSaved: Math.round(sessionsSaved),
        hoursSaved: Math.round(hoursSaved),
        dollarsSaved: Math.round(dollarsSaved),
        chainsBought: chainsBought,
        revenueDays: revenueDays
      };
    }

    function humourFor(sessions) {
      for (var i = 0; i < humourBands.length; i++) {
        if (sessions <= humourBands[i].max) return humourBands[i].line;
      }
      return humourBands[humourBands.length - 1].line;
    }

    function formatDollar(n) {
      return '$' + Math.round(n).toLocaleString('en-AU');
    }

    function render() {
      var inputs = getInputs();
      var r = calc(inputs);

      var hoursOut = root.querySelector('[data-output="hours_per_week"]');
      var sharpenOut = root.querySelector('[data-output="sharpen_minutes"]');
      var hourlyOut = root.querySelector('[data-output="hourly_value"]');
      if (hoursOut) hoursOut.textContent = inputs.hours_per_week;
      if (sharpenOut) sharpenOut.textContent = inputs.sharpen_minutes;
      if (hourlyOut) hourlyOut.textContent = '$' + inputs.hourly_value;

      var hoursSavedEl = root.querySelector('[data-value="hours_saved"]');
      var dollarsSavedEl = root.querySelector('[data-value="dollars_saved"]');
      var sessionsEl = root.querySelector('[data-value="sessions_saved"]');
      var humourEl = root.querySelector('[data-value="humour_line"]');
      var chainsBoughtEl = root.querySelector('[data-value="chains_bought"]');
      var revenueDaysEl = root.querySelector('[data-value="revenue_days"]');

      if (hoursSavedEl) hoursSavedEl.textContent = r.hoursSaved.toLocaleString('en-AU');
      if (dollarsSavedEl) dollarsSavedEl.textContent = formatDollar(r.dollarsSaved);
      if (sessionsEl) sessionsEl.textContent = r.sessionsSaved;
      if (humourEl) humourEl.textContent = humourFor(r.sessionsSaved);
      if (chainsBoughtEl) chainsBoughtEl.textContent = r.chainsBought.toLocaleString('en-AU');
      if (revenueDaysEl) revenueDaysEl.textContent = r.revenueDays.toLocaleString('en-AU');

      root.querySelectorAll('.cro-calc__slider').forEach(function (slider) {
        var key = slider.getAttribute('data-input');
        var v = slider.value;
        if (key === 'hours_per_week') slider.setAttribute('aria-valuetext', v + ' hours per week');
        if (key === 'sharpen_minutes') slider.setAttribute('aria-valuetext', v + ' minutes per sharpening');
        if (key === 'hourly_value') slider.setAttribute('aria-valuetext', v + ' dollars per hour');
      });
    }

    root.querySelectorAll('[data-input]').forEach(function (el) {
      el.addEventListener('input', render);
      el.addEventListener('change', render);
    });

    // Radio is-selected shim for browsers without :has() support
    function syncIntensitySelected() {
      root.querySelectorAll('.cro-calc__intensity label').forEach(function (l) {
        var radio = l.querySelector('input[type="radio"]');
        if (radio && radio.checked) {
          l.classList.add('is-selected');
        } else {
          l.classList.remove('is-selected');
        }
      });
    }
    root.querySelectorAll('.cro-calc__intensity input[type="radio"]').forEach(function (radio) {
      radio.addEventListener('change', syncIntensitySelected);
    });
    syncIntensitySelected();

    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro-video-row"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function isYouTube(url) {
    return /(?:youtube\.com|youtu\.be)/i.test(url);
  }
  function isVimeo(url) {
    return /vimeo\.com/i.test(url);
  }
  function youtubeEmbed(url) {
    var m = url.match(/(?:v=|youtu\.be\/|embed\/)([A-Za-z0-9_-]{6,})/);
    if (!m) return null;
    return 'https://www.youtube-nocookie.com/embed/' + m[1] + '?autoplay=1&rel=0&modestbranding=1';
  }
  function vimeoEmbed(url) {
    var m = url.match(/vimeo\.com\/(\d+)/);
    if (!m) return null;
    return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
  }

  function openModal(tile) {
    var modalId = tile.getAttribute('data-modal-target');
    var modal = document.getElementById(modalId);
    if (!modal) return;

    var mediaContainer = modal.querySelector('[data-modal-media]');
    var videoUrl = tile.getAttribute('data-video-url');
    var source = tile.getAttribute('data-video-source');

    mediaContainer.innerHTML = '';

    if (!videoUrl) {
      mediaContainer.innerHTML = '<p style="color:#fff;text-align:center;padding:2rem;">No video configured.</p>';
    } else if (source === 'external_url' && isYouTube(videoUrl)) {
      var ytEmbed = youtubeEmbed(videoUrl);
      if (ytEmbed) {
        var iframe = document.createElement('iframe');
        iframe.src = ytEmbed;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.setAttribute('allowfullscreen', '');
        mediaContainer.appendChild(iframe);
      }
    } else if (source === 'external_url' && isVimeo(videoUrl)) {
      var vEmbed = vimeoEmbed(videoUrl);
      if (vEmbed) {
        var iframeV = document.createElement('iframe');
        iframeV.src = vEmbed;
        iframeV.allow = 'autoplay; fullscreen';
        iframeV.setAttribute('allowfullscreen', '');
        mediaContainer.appendChild(iframeV);
      }
    } else {
      var video = document.createElement('video');
      video.src = videoUrl;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.preload = 'auto';
      mediaContainer.appendChild(video);
    }

    modal.hidden = false;
    document.body.classList.add('cro-modal-open');

    var firstFocusable = modal.querySelector('[data-modal-close]');
    if (firstFocusable) firstFocusable.focus();

    modal.__previousActive = tile;
  }

  function closeModal(modal) {
    if (!modal) return;
    var media = modal.querySelector('[data-modal-media]');
    if (media) media.innerHTML = '';
    modal.hidden = true;
    document.body.classList.remove('cro-modal-open');
    if (modal.__previousActive) {
      modal.__previousActive.focus();
      modal.__previousActive = null;
    }
  }

  function init() {
    document.querySelectorAll('.cro-video-tile').forEach(function (tile) {
      if (tile.__croBound) return;
      tile.__croBound = true;
      tile.addEventListener('click', function () { openModal(tile); });
    });

    document.querySelectorAll('.cro-video-modal').forEach(function (modal) {
      if (modal.__croBound) return;
      modal.__croBound = true;
      modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
        el.addEventListener('click', function () { closeModal(modal); });
      });
    });

    if (!window.__croVideoEscBound) {
      window.__croVideoEscBound = true;
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          document.querySelectorAll('.cro-video-modal:not([hidden])').forEach(closeModal);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
